// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Reselect = require("reselect");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function uncurry(fn, x) {
  return fn(x);
}

function memoizeOutputRef(shouldUsePrev) {
  var prev = {
    contents: undefined
  };
  return function (next) {
    var prev$1 = prev.contents;
    var tmp;
    if (prev$1 !== undefined) {
      var prevArgs = prev$1.prevArgs;
      tmp = prevArgs === next || Curry._2(shouldUsePrev, next, prevArgs) ? ({
            prevArgs: next,
            prevResult: prev$1.prevResult
          }) : ({
            prevArgs: next,
            prevResult: next
          });
    } else {
      tmp = {
        prevArgs: next,
        prevResult: next
      };
    }
    prev.contents = Relude_Option.pure(tmp);
    return Relude_Option.fold(next, (function (param) {
                  return param.prevResult;
                }), prev.contents);
  };
}

function createSelector1(shouldUsePrev, a, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, Curry.__1(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector2(shouldUsePrev, a, b, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, Curry.__2(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector3(shouldUsePrev, a, b, c, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, Curry.__3(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector4(shouldUsePrev, a, b, c, d, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, Curry.__4(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector5(shouldUsePrev, a, b, c, d, e, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, Curry.__5(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector6(shouldUsePrev, a, b, c, d, e, f, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, f, Curry.__6(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector7(shouldUsePrev, a, b, c, d, e, f, g, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, f, g, Curry.__7(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector8(shouldUsePrev, a, b, c, d, e, f, g, h, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, f, g, h, Curry.__8(combiner));
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector9(shouldUsePrev, a, b, c, d, e, f, g, h, i, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, f, g, h, i, combiner);
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector10(shouldUsePrev, a, b, c, d, e, f, g, h, i, j, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, f, g, h, i, j, combiner);
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function createSelector11(shouldUsePrev, a, b, c, d, e, f, g, h, i, j, k, combiner) {
  var partial_arg = Relude_Option.fold(Relude_Globals.id, memoizeOutputRef, shouldUsePrev);
  var partial_arg$1 = Reselect.createSelector(a, b, c, d, e, f, g, h, i, j, k, combiner);
  var partial_arg$2 = function (param) {
    return partial_arg$1(param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

exports.uncurry = uncurry;
exports.memoizeOutputRef = memoizeOutputRef;
exports.createSelector1 = createSelector1;
exports.createSelector2 = createSelector2;
exports.createSelector3 = createSelector3;
exports.createSelector4 = createSelector4;
exports.createSelector5 = createSelector5;
exports.createSelector6 = createSelector6;
exports.createSelector7 = createSelector7;
exports.createSelector8 = createSelector8;
exports.createSelector9 = createSelector9;
exports.createSelector10 = createSelector10;
exports.createSelector11 = createSelector11;
/* reselect Not a pure module */
